import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/MerchantLogos/GET';

export const MERCHANT_LOGOS_GET_SUCCESS = `${rootActionPath}_${SUCCESS_SUFFIX}`;
export const MERCHANT_LOGOS_GET_FAILURE = `${rootActionPath}_${FAILURE_SUFFIX}`;
